module.exports = __webpack_public_path__ + "static/media/bg_mirrored.072cd066.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/People/bg_mirrored.jpg
// module id = 111
// module chunks = 0